module.exports = __webpack_public_path__ + "static/img/Ariel.Steinberg.7b4db9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ariel.Steinberg.jpg
// module id = hnUX
// module chunks = 0